import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { TreeView } from '@mui/x-tree-view/TreeView'
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem'
import axios from 'axios'
import { Stack } from '@mui/material'
import { Paper } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import {
  conflictDataActions,
  feedbackActions,
  shelfViewFeedbackActions,
  thumbnailStoreActions
} from '../store/store'
import { socket } from '../socket'
import TextField from "@mui/material/TextField";
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { StyledAutocompleteBlue } from './components/styled_autocomplete'
import {Form, DatePicker } from "antd";
import moment from 'moment';
import "./annotator.css";
import { alpha, styled } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import { useSpring, animated } from '@react-spring/web';
import Collapse from '@mui/material/Collapse';
import { resetAllDataOfPopUp, setCurPage, setPrevPage } from '../store/ShelfView/conflictsPage'
import { toLower } from 'lodash'
import { resetCursorDetails, updateThumbnailDetailsAndKey } from '../store/ShelfView/conflictThumbnail'
import { resetPopOver } from '../store/ShelfView/popover';
import dayjs from "dayjs";


const { RangePicker } = DatePicker;

/**
 * search Database - active / archived
 * search mode - verified / unverified
 * projectName - opti_live1 / ira-india
 * date range
 */

export default function AnnotatorSidebar() {
  const {
    projectOptions,
    searchDatabaseOptions,
    searchModeOptions,
    type,
    dataType,
    selectedType,
    hierarchyData
  } = useSelector(state => state.thumbnailStore)
  const {
    conflicts, curConflict
  } = useSelector(state => state.conflictDataStore);
  const { user, username, userId } = useSelector(state => state.userStore)
  const { curPage}=useSelector((state)=>state.conflictsPageStore)
  const { cursorDetails } = useSelector(state => state.thumbnailStore);
  const {
    cursorDetails2
  } = useSelector(state => state.conflictThumbnailStore);
  const thumbnails = cursorDetails2.thumbnailDetails;
  
  const {
    project,
    searchDatabase,
    searchMode,
    sd,
    ed,
  } = cursorDetails;
//console.log(sd,ed)
  const dispatch = useDispatch();
  const useAutoCompleteStyles = makeStyles({
    option: {
      fontSize: '0.875rem',
    },
  });
  const autocomplete_classes = useAutoCompleteStyles();
  //console.log('cursor data', cursorDetails)

  const handleClickNode = e => {
    //console.log('e', e)

    // dispatch(feedbackActions.setSnackbarOpen(true));
    // dispatch(feedbackActions.setSnackbarMessage("Data unavailable!"));
    // dispatch(feedbackActions.setSnackbarMessageSeverity("warning"))
  }

  useEffect(() => {
    socket.on('chat_message', msg => {
      console.log('msg', msg)
    })
    socket.emit(
      'get_data',
      JSON.stringify({
        user: user,
        username: username,
        userId: userId
      })
    )
  }, [])
 // console.log(curConflict)
 useEffect(()=>{
  const func=async()=>{
    try{
      if(cursorDetails.project===""){
        const response=await axios.post("/customAPIs/get_all_projects");
        dispatch(thumbnailStoreActions.setProjectList(response.data))
        dispatch(thumbnailStoreActions.updateAnnotatorConfig({
          type: 'project',
          value: response.data.length>0?response.data[0]:"",
        }))
      }
     
      // console.log(response.data)
    }
    catch(error){
      console.log(error)
    }
  }
  func();
 
 },[])
//  console.log(cursorDetails,"cursor details")
  const get_node_info = async e => {
   // console.log('-----------------------------------------', e)

    // not calling API when children are already available
    if (e.children.length > 0) {
      return
    }
     
    const params = {
      ...cursorDetails,
      dataType: e.dataType,
      selectedType: e.type,
      selectedValue: e.name,
      currentKey: ""
    }
    try{
      const response = await axios.post("/customAPIs/get_range");
      //console.log(response.data,"hiii")
     
      dispatch(thumbnailStoreActions.resetCursorDetails(response.data))
     
    }
    catch(error){
      console.log(error)
    }
    dispatch(shelfViewFeedbackActions.setLoading(true))
    if(cursorDetails.project !== "" && cursorDetails.sd !== "" && cursorDetails.ed !== "")
    {
      try{
        const response = await axios.post(
          '/thumbnail_transaction/get_node_data',
          params
        )
    
        if (response.status !== 200) {
          dispatch(shelfViewFeedbackActions.setLoading(false))
          return
        }
    
        // console.log('response ', response.data);
    
    
        dispatch(thumbnailStoreActions.updateHierarchyData(response.data))
       
      }
      catch(error)
      {
        console.log(error,"error")
      }
    }
    else
    {
      dispatch(feedbackActions.setSnackbarOpen(true))
      dispatch(
        feedbackActions.setSnackbarMessage(
          'Date not selected !'
        )
      )
      dispatch(feedbackActions.setSnackbarMessageSeverity('warning'))
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    }
   
    dispatch(shelfViewFeedbackActions.setLoading(false))
    
  }

  function MinusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
      </SvgIcon>
    );
  }
  
  function PlusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
      </SvgIcon>
    );
  }
  
  function CloseSquare(props) {
    return (
      <SvgIcon
        className="close"
        fontSize="inherit"
        style={{ width: 14, height: 14 }}
        {...props}
      >
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
      </SvgIcon>
    );
  }

  function TransitionComponent(props) {
    const style = useSpring({
      to: {
        opacity: props.in ? 1 : 0,
        // transform: `scale(${props.in ? 1 : 0})`,
        transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
      },
    });
  
    return (
      <animated.div style={style}>
        <Collapse {...props} />
      </animated.div>
    );
  }
  
  const CustomTreeItem = React.forwardRef((props, ref) => (
    <TreeItem {...props} TransitionComponent={TransitionComponent} ref={ref} />
  ));
  

  const StyledTreeItem = styled(CustomTreeItem)(({ theme }) => ({
    [`& .${treeItemClasses.iconContainer}`]: {
      '& .close': {
        opacity: 0.3,
      },
    },
    [`& .${treeItemClasses.group}`]: {
      marginLeft: 15,
      paddingLeft: 15,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.25)}`,
    },
  }));

  const renderTree = nodes => (
    <StyledTreeItem
      key={nodes.id}
      nodeId={nodes.id}
      label={nodes.name}
      onClick={() => get_node_info(nodes)}
      sx={{
        "& .MuiTreeItem-label": {
          fontFamily: "ChalkboardSE-Regular !important",
          fontSize: "13.5px",
          color: "rgb(80, 80, 80)",
          
        }
      }}
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map(node => renderTree(node))
        : null}
    </StyledTreeItem>
  )

  const handleAnnotatorOptionChange = async(e, type) => {
   
   
    try{
      const response = await axios.post("/customAPIs/get_range");
     // console.log(response.data,"hiii")
      dispatch(resetCursorDetails(response.data))
      dispatch(thumbnailStoreActions.resetCursorDetails(response.data))
      dispatch(thumbnailStoreActions.resetHierarchyData())
      dispatch(conflictDataActions.resetConflictedData());
      dispatch(resetAllDataOfPopUp());
      dispatch(resetPopOver())
      dispatch(thumbnailStoreActions.updateAnnotatorConfig({
        type: type,
        value: e,
      }))
    }
    catch(error){
      console.log(error)
    }
   
   

  }

  const handleDateChange = (dates) => {
    //console.log(dates)
    if(dates!==null)
    {
      const sd = moment(dates[0].$d).format('YYYY-MM-DD');
      const ed = moment(dates[1].$d).format('YYYY-MM-DD');
     // console.log('dates', dates);
  
      dispatch(thumbnailStoreActions.updateAnnotatorConfig({
        type: "sd",
        value: sd,
      }))
      dispatch(thumbnailStoreActions.updateAnnotatorConfig({
        type: "ed",
        value: ed,
      }))
    }
   
  };

  const handleNodeChange=(event)=>{
    dispatch(setPrevPage(curPage))
    dispatch(setCurPage("default"))
    dispatch(resetPopOver())
  
  }
  const handlePage=async(event)=>{
    const resetData={
      thumbnailDetails:[],
      currentKey:null
     }
    dispatch(shelfViewFeedbackActions.setLoading(true));
  dispatch(updateThumbnailDetailsAndKey(resetData))
    dispatch(conflictDataActions.resetSelectedThumbnailsToMarkCorrect())
    let page=toLower(event.target.textContent);
    page = page.split(' ').join('-');
    dispatch(conflictDataActions.setCurConflict(page))
    dispatch(setPrevPage(curPage))
    dispatch(setCurPage("conflicts"));
    
    if(cursorDetails.project!=="")
    {
      try{
        //console.log("called sidebar !!")
        const response =await axios.post("/markThumbnail/renderThumbnails",{type_of_issue:page, ...cursorDetails});
       // console.log(response.data)
        dispatch(updateThumbnailDetailsAndKey(response.data))
        dispatch(conflictDataActions.setConflictedBrands(response.data))
        dispatch(conflictDataActions.setSelectedConflictedBrand(null))
      }catch(error){
        console.log(error,"error");
      }
  
    }
    else
    {
      dispatch(feedbackActions.setSnackbarOpen(true))
      dispatch(
        feedbackActions.setSnackbarMessage(
          'No project selected !'
        )
      )
      dispatch(feedbackActions.setSnackbarMessageSeverity('warning'))
      setTimeout(() => {
        dispatch(feedbackActions.setSnackbarOpen(false));
      }, 5000);
    }
   
   dispatch(shelfViewFeedbackActions.setLoading(false));
   }
//console.log (moment(sd).format('YYYY-MM-DD'), moment(ed).format('YYYY-MM-DD'))
  return (
    <Stack sx={{height:"88vh",maxHeight: "90vh",overflowY:"auto", '@media screen and (max-height: 1200px)': {
      height: '100vh', 
    },
    '@media screen and (max-height: 1000px)': {
      height: '89vh', 
    },
    '@media screen and (max-height: 950px)': {
      height: '79vh', 
    },
    '@media screen and (max-height: 930px)': {
      height: '94vh', 
    },
    '@media screen and (max-height: 600px)': {
      height: '89vh', 
    },
   }}>
    <Stack spacing={2} sx={{ display: "flex", justifyContent: "space-between",paddingTop:"0.5rem", paddingRight:"1rem",width: 250, }}>
      <Stack spacing={2}>

        {/* Annotator config */}
        <Stack spacing={2} direction='row'>
          <StyledAutocompleteBlue
            sx={{ width: '15rem' }}
            classes={{
              option: autocomplete_classes.option
            }}
            id='size-small-outlined-multi'
            size='small'
            noOptionsText='Loading...'
            value={searchDatabase}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={searchDatabaseOptions}
            getOptionLabel={option => option}
            renderInput={params => (
              <TextField
                {...params}
                variant='outlined'
                placeholder={`Search database`}
                label="Database"
              />
            )}
            onChange={(event, value) => handleAnnotatorOptionChange(value, 'searchDatabase')}
          />

          <StyledAutocompleteBlue
            sx={{ width: '15rem' }}
            classes={{
              option: autocomplete_classes.option
            }}
            id='size-small-outlined-multi'
            size='small'
            noOptionsText='Loading...'
            value={searchMode}
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            options={searchModeOptions}
            getOptionLabel={option => option}
            renderInput={params => (
              <TextField
                {...params}
                variant='outlined'
                placeholder={`Search mode`}
                label="Mode"
              />
            )}
            onChange={(event, value) => handleAnnotatorOptionChange(value, 'searchMode')}
          />
        </Stack>

        <StyledAutocompleteBlue
          sx={{ width: '100%',marginTop:"2px" }}
          classes={{
            option: autocomplete_classes.option
          }}
          id='size-small-outlined-multi'
          size='small'
          noOptionsText='Loading...'
          //value={project}
          value={project || (projectOptions.length > 0 ? projectOptions[0] : null)}
          componentsProps={{ popper: { style: { minWidth: '15rem' } } }}
          options={projectOptions}
          getOptionLabel={option => option}
          renderInput={params => (
            <TextField
              {...params}
              variant='outlined'
              placeholder={`Select a project`}
              label="Project"
            />
          )}
          onChange={(event, value) => handleAnnotatorOptionChange(value, 'project')}
        />

        {/* <RangePicker
          onChange={handleDateChange}
          style={{ color: "black" }}
          className="custom-range-picker" 
          // value={[moment(sd), moment(ed)]}
          // placeholder={[sd!==""?moment(sd).format('YYYY-MM-DD'):"Start Date", ed!==""?moment(ed).format('YYYY-MM-DD'):"End Date"]}
        /> */}
         <Form style={{height:"4vh"}}>
        <Form.Item
          name="dateRange"
          initialValue={sd !=="" && [dayjs(sd), ed !=="" && dayjs(ed)]}
          style={{height:"4vh"}}
         
        >
          <DatePicker.RangePicker onChange={handleDateChange}/>
        </Form.Item>
      </Form>

        <TreeView
          className="annotator-sidebar"
          aria-label='rich object'
          defaultExpanded={["root"]}
          defaultCollapseIcon={<MinusSquare />}
          defaultExpandIcon={<PlusSquare />}
          defaultEndIcon={<CloseSquare />}
          onClick={handleNodeChange}
          sx={{
          marginTop:"1px",
            height: '50vh',
            width: "100%",
            overflowY: 'auto',
            '@media screen and (max-height: 1200px)': {
              height: '64vh', 
            },
            '@media screen and (max-height: 1000px)': {
              height: '60vh', 
            },
            '@media screen and (max-height: 930px)': {
              height: '59vh', 
            },
            '@media screen and (max-height: 900px)': {
              height: '53vh', 
            },
            '@media screen and (max-height: 700px)': {
              height: '45vh', 
            },
            '@media screen and (max-height: 600px)': {
              height: '40vh', 
            },
            '@media screen and (max-height: 500px)': {
              height: '30vh', 
            },
            '@media screen and (max-height: 401px)': {
              height: '28vh', 
            },
            '@media screen and (max-height: 301px)': {
              height: '20vh', 
            },
          }}
        >
          {renderTree(hierarchyData)}
        </TreeView>
      </Stack>
     
      {/* conflict tabs */}
      <Stack
        spacing={1.5}
        className="conflict-tabs-container"
        sx={{ borderRadius: "10px" ,position: "fixed", left: "0", bottom: "0",marginTop:"1rem"}}
      >
        <span className="conflict-label">Conflicts</span>
       
        <div className="conflict-tabs">
          {conflicts.map(r => (
            <div className="conflict-tab" onClick={handlePage}>{r}</div>
          ))}
        </div>
        
      </Stack>
    </Stack>
    </Stack>
  )
}
